/* pixta画像の右クリックを制限する関数
 *
 * pixta_の文字列をsrcに含むimgの右クリックとドラッグを制御
*/

const disabledPixtaRightClick = () => {
  const allImgNodes = document.querySelectorAll('img');
  const $allImg = Array.prototype.slice.call(allImgNodes, 0);

  function isPixtaImg (el) {
    return el.getAttribute('src').indexOf('pixta_') > 0;
  }

  function addEvents () {
    $allImg.forEach(el => {
      el.oncontextmenu = () => {
        if (isPixtaImg(el)) {
          return false;
        }
      };
      el.oncopy = () => {
        if (isPixtaImg(el)) {
          return false;
        }
      };
      el.ondragstart = () => {
        if (isPixtaImg(el)) {
          return false;
        }
      };
    });
  }

  function init () {
    addEvents();
  }

  init();
};

window.addEventListener('DOMContentLoaded', () => {
  disabledPixtaRightClick();
});
